import { useEffect, useMemo, useState } from 'react';
import Frame from '../Frames/Basic'
import { useNavigate, useParams } from "react-router-dom";
import API from '../../services/API';
import Loader from '../Tools/Loader';
import { Alert, Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { ArrowBack, Download } from '@mui/icons-material';
import PDF from '../Tools/PDF';

/**
 * Page réservée aux profils Admin
 * - pour vérifier si l'attestation a été signée
 * - pour télécharger le modèle si besoin
 */
export default function AdminParticipation(){

    const navigate = useNavigate()

    const { id } = useParams();

    const [status, setStatus] = useState('loading');

    const [data, setData] = useState(null)

    useEffect(() => {

        API.get(`/signatures/pi/${id}`)
            .then(r => {
                setStatus('ready')
                setData(r.data)
                console.log(r.data)
            })
            .catch(_ => setStatus('notfound'))

    }, [id])

    const signatureUrl = useMemo(() => `${window.location.protocol}//${window.location.host}/app/dpc/participation/${id}/signature`, [id])

    return (
        <Frame>

            <Stack spacing={2}>

                <Stack direction="row" alignItems="center" spacing={1}>

                    <IconButton onClick={() => navigate(-1)}>
                        <ArrowBack/>
                    </IconButton>

                    <Typography variant="h1">Attestation de participation</Typography>

                </Stack>

                {status === 'loading' &&
                    <Loader />
                }

                {status === 'notfound' && <>

                    <Alert severity="warning">
                        L'attestation n'a pas été signée. Elle doit être signée électroniquement à la fin de la session DPC.
                    </Alert>

                    <Typography>
                        Lien de la signature électronique :
                        <br/>
                        <small style={{color: 'grey', wordBreak: 'break-all'}}>{signatureUrl}</small>
                    </Typography>
                    

                    <Box>
                        <Button
                            startIcon={<Download />}
                            href={API.url(`/dpc/registrations/${id}/participation?model=1`)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Télécharger le modèle
                        </Button>
                    </Box>

                </>}

                {status === 'ready' && <>

                    <Alert severity={data.signed ? 'success' : 'warning'}>
                        {data.signed ? 
                            `L'attestation a été signée.` 
                            : 
                            `Vous devez signer électroniquement votre attestation.`
                        }
                    </Alert>

                    <Box>
                        <Button
                            startIcon={<Download />}
                            href={API.url(`/signatures/${data.id}/document.pdf`)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Télécharger le document
                        </Button>
                    </Box>

                    <PDF url={API.url(`/signatures/${data.id}/document.pdf`)} />

                </>}

            </Stack>

        </Frame>
    );
}
